import { createContext, useContext, useCallback } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);

function resolve(dict, path) {
  return path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), dict);
}

export function I18nProvider({ children }) {
  // Control OS is German-only: every label, error and help text is shown in German.
  const lang = "de";
  const setLang = useCallback(() => {}, []);

  const t = useCallback(
    (path, params) => {
      let value = resolve(translations[lang], path);
      if (value === undefined) value = resolve(translations.de, path);
      if (value === undefined) return path;
      if (params && typeof value === "string") {
        return value.replace(/\{(\w+)\}/g, (m, k) => (params[k] !== undefined ? params[k] : m));
      }
      return value;
    },
    [lang]
  );

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
